<template>
  <div class="w-full flex flex-col">
    <!-- Scores -->
    <div class="flex items-center gap-1.5 h-16 mt-2">
      <MetricsIcon class="text-icon-muted" />
      <BaseText type="heading" size="sm" class="my-5">
        Foreplay Scores
      </BaseText>
    </div>
    <!-- Calculated -->
    <div class="flex flex-col gap-4">
      <div v-for="(subcategory, index) in metricSubcategories" :key="`fpm-subcategory-${index}`" class="flex flex-col gap-2.5">
        <BaseText id="calculated-scores" ref="calculated-scores" type="heading" size="overline" class="text-text-subdued uppercase metric-section">
          {{ subcategory.categoryTitle }}
        </BaseText>
        <div class="grid grid-cols-2 gap-2">
          <div v-for="metric in subcategory.metrics" :key="`fp-metric-${metric.key}`"
          class="col-span-2 lg:col-span-1 flex items-start gap-4 p-3 rounded-xl border border-border-normal cursor-pointer
          transition-colors duration-100 hover:border-border-hover"
          @click="$emit('metricAdd', metric.key)">
            <div class="flex flex-col gap-1 text-left min-w-0">
              <BaseText type="label" size="sm" class="text-text-muted">
                {{ metric.name }}
              </BaseText>
              <BaseText type="body" size="sm" class="text-text-normal">
                {{ metric.description }}
              </BaseText>
            </div>
            <input type="checkbox" :checked="selectedColumns.includes(metric.key)"
            class="ml-auto h-4 w-4 rounded checkbox-input text-black cursor-pointer focus:ring-transparent transition-colors">
          </div>
          <!-- Learn more -->
          <a href="https://foreplay.featurebase.app/en/help/articles/3072575-foreplay-scores" target="_blank" class="learn-btn cursor-pointer flex flex-col gap-1.5 col-span-2 
          lg:col-span-1 relative p-5 rounded-xl border border-border-normal overflow-hidden">
            <!-- Lens icon -->
            <FPLensMetricsIcon class="absolute -bottom-12 right-0" :width="115" :height="125"/>
            <BaseText type="body" size="sm" class="text-white opacity-60">
              Learn more about
            </BaseText>
            <div class="flex gap-1">
              <MetricsIcon class="text-white" />
              <BaseText type="label" size="sm" class="text-white">
                Foreplay Scores
              </BaseText>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- Disclaimer -->
    <div class="w-full flex items-start gap-2 pl-2.5 pr-4 py-2.5 mt-5 rounded-md bg-neutral-25">
      <InfoRectIcon class="text-text-subdued flex-shrink-0" />
      <BaseText type="body" size="sm" class="text-text-normal">
        For best results, it is recommended to only use Foreplay scores in top performing reports that are grouped by "Ad Name" or "Creative".
      </BaseText>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Icons
import MetricsIcon from '../../../globals/Icons/LensIcons/MetricsIcon.vue'
import FPLensMetricsIcon from '../../../globals/Icons/LensIcons/FPLensMetricsIcon.vue'
import InfoRectIcon from '../../../globals/Icons/InfoRectIcon.vue'

export default {
  name: 'ForeplayMetricsSettings',
  components: {
    MetricsIcon,
    FPLensMetricsIcon,
    InfoRectIcon
  },
  props: {
    selectedColumns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetrics']),
    metricSubcategories () {
      const subcategories = this.getMetrics?.foreplay_metrics?.subSections
      if (!subcategories) return []
      return subcategories.map(category => ({
        categoryTitle: _.startCase(category.sectionId),
        metrics: [...category.metrics]
      }))
    }
  }
}
</script>

<style scoped>
.learn-btn {
background-color: #06070f;
  transition: all 100ms;
}
.learn-btn:hover {
  background-color: rgba(6, 7, 15, 0.92);
}
.checkbox-input {
  border: 1px;
  box-shadow: 0px 0px 0px 1px rgba(9, 25, 72, 0.13), 0px 1px 2px 0px rgba(9, 25, 72, 0.13);
}
</style>
